import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Layout } from "antd";
import LayoutHeader from "./layoutHeader";
import ProtectedRoute from "./ProtectedRoute";
import SideBaruser from "./sideBar";
import Client from "../client/client";
import ClientProject from "../client/project_client/clientProject";
import ClientTask from "../client/task_client/clientTask";
import ViewTask from "../client/task_client/viewTask";
import PaymentDetails from "../client/paymentDetails";

const ClientNavigation = () => {
  const user = useSelector((state: any) => state.user);
  const [collapsed, setCollapsed] = useState(false);
  const { Sider, Content } = Layout;

  return (
    <Layout>
      <Sider
        style={{ backgroundColor: "#FF1A1A", height: "100vh" }}
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={collapsed ? 40 : 250}
      >
        <SideBaruser
          collapsed={collapsed}
          doCollapse={() => setCollapsed(!collapsed)}
        />
      </Sider>
      <Layout>
        <LayoutHeader />
        <Content style={{ background: "#fff" }}>
          <Routes>
            <Route path="/" element={<Client />} />

            <Route
              path="/Client_Dashboard"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Client />
                </ProtectedRoute>
              }
            />

            <Route
              path="/Project_details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ClientProject />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Project_details/projectview/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ClientTask />
                </ProtectedRoute>
              }
            />
            <Route
              path="/task_details/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ViewTask />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Payment_details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <PaymentDetails />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default ClientNavigation;
